import { render } from "./Face.vue?vue&type=template&id=712df9a5"
import script from "./Face.vue?vue&type=script&lang=js"
export * from "./Face.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__